import React from "react";

import {
    ArticlePageHero,
    ImageChooserBlock as ImageChooserBlockType,
    constants,
} from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { ValueOf } from "../../utils/types";
import { H } from "../Headings";
import { Separator } from "../Separator";
import { Share } from "../Share";

import styles from "./ArticleHero.module.scss";

export type AspectRatio = ValueOf<
    (typeof constants)["server.cms.types.ArticleAspectRatioChoices"]
>;
interface Props extends ArticlePageHero {
    category: string;
    title: string;
    subtitle: string;
    url: string;
    media?: ImageChooserBlockType;
    mediaAspectRatio?: AspectRatio;
}

type Ratio = `${number} / ${number}`;

export const getRatioForAspect = (name: AspectRatio): Ratio => {
    switch (name) {
        case "landscape":
            return "3 / 2";
        case "portrait":
            return "3 / 4";
        default:
            return "1 / 1";
    }
};

export const ArticleHero = ({ variant = "split", ...props }: Props) => {
    if (!props.media) variant = "none";
    // both "fullbleed" and "none" variations have text centered the same way,
    // so the same styles can handle them both
    return (
        <div className={variant === "split" ? styles.split : styles.fullbleed}>
            {variant !== "none" && props.media && (
                <>
                    <ImageChooserBlock
                        attrs={{
                            className: styles.media,
                            style:
                                props.mediaAspectRatio &&
                                variant !== "fullbleed"
                                    ? {
                                          "--image-ar": getRatioForAspect(
                                              props.mediaAspectRatio,
                                          ),
                                      }
                                    : undefined,
                        }}
                        value={props.media}
                    />
                    {variant === "split" && (
                        <Separator orientation="vertical" />
                    )}
                </>
            )}
            <div className={styles.text}>
                <p className={styles.category}>{props.category}</p>
                <H className={styles.title}>{props.title}</H>
                <p className={styles.subtitle}>{props.subtitle}</p>
                <Share url={props.url} />
            </div>
        </div>
    );
};
